import {createReducer, on} from '@ngrx/store';
import {ViewportSize} from '@aviary/store/viewport/viewport.types';
import {ViewportActions} from '@aviary/store/viewport/viewport.actions';

export interface ViewportState {
  viewportSize: ViewportSize;
}

export const INITIAL_VIEWPORT_STATE: ViewportState = {
  viewportSize: 'sm'
};

export const viewportState = createReducer(
  INITIAL_VIEWPORT_STATE,
  on(ViewportActions.sizeChanged, (state, {newSize}) => ({
    ...state,
    viewportSize: newSize
  }))
);
